export const apiUrl = process.env.REACT_APP_API_URL;
export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const config = {
  apiUrl,
  googleMapsApiKey,
};

export default config;
